module.exports = {"140225100":"永安镇","140225101":"西坊城镇","140225102":"蔡村镇","140225103":"沙圪坨镇","140225104":"王庄堡镇","140225105":"大磁窑镇","140225201":"东坊城乡","140225203":"裴村乡","140225204":"驼峰乡","140225205":"西留村乡","140225206":"下韩村乡","140225208":"南榆林乡","140225210":"吴城乡","140225212":"黄花滩乡","140225213":"大仁庄乡","140225215":"千佛岭乡","140225218":"官儿乡","140225220":"青磁窑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140225.json
// module id = 248
// module chunks = 0